<template>
  <div>
    <el-table border strip :data="Conn">
      <el-table-column :label="`${$t('lang.smartlink.enable')}`">
        <template slot-scope="scope">
          <span>{{ scope.row.options.enabled == '1' ? '✔' : '✖' }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.smartlink.name')}`" prop="name">
        <template slot-scope="scope">
          <span>{{ scope.row.options.name }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.smartlink.workingMode')}`">
        <template slot-scope="scope">
          <!-- <span>{{scope.row.options.mode}}</span> -->
          <span>{{ workModel[scope.row.options.mode] || scope.row.options.mode }}</span>
        </template>
      </el-table-column>
      <!-- 需要根据工作模式来判断目标地址对应显示的是什么内容 -->
      <el-table-column :label="`${$t('lang.smartlink.targetAddress')}`" min-width="100px">
        <template slot-scope="scope">
          <div
            v-if="scope.row.options.mode === 'TCP Client' || scope.row.options.mode === 'MQTT Client' || scope.row.options.mode === 'UDP Client'">
            <div v-for="(item, index) in scope.row.lists.server" :key="index">
              <span>{{ item }}</span>
            </div>
          </div>
          <div v-else-if="scope.row.options.mode === 'Modbus TCP Master'">
            <div v-for="(item, index) in scope.row.lists.slave_addr" :key="index">
              <span>{{ item }}</span>
            </div>
          </div>
          <span v-else-if="devName.includes(scope.row.options.mode)">{{ scope.row.options.dev_name }}</span>
          <span v-else-if="scope.row.options.mode === 'Modbus TCP Slave'">{{ scope.row.options.slave_port }}</span>
          <div v-else-if="scope.row.options.mode === 'Local Server'">
            <span v-if="scope.row.options.proto == 'DAQ'">/etc/config/modbus</span>
            <span v-if="scope.row.options.proto == 'IO Control'">/sys/class/gpio</span>
            <div v-for="(item, index) in scope.row.lists.server" :key="index">
              <span>{{ item }}</span>
            </div>
          </div>
          <span v-else-if="scope.row.options.listen_port">{{ scope.row.options.listen_port }}</span>
          <span v-else-if="scope.row.options.uds_server_path">{{ scope.row.options.uds_server_path }}</span>
          <span v-else-if="scope.row.lists.server.length > 0">{{ scope.row.lists.server[0] }}</span>
          <span v-else>{{ scope.row.options.aiot_server }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.smartlink.status')}`" prop>
        <template slot-scope="scope">
          <span v-if="!scope.row.options.enabled">{{ $t('lang.smartlink.disconnect') }}</span>
          <span v-else-if="scope.row.options.status == 'connected'">{{ $t('lang.smartlink.connected') }}</span>
          <span v-else-if="scope.row.options.status == 'listening'">{{ $t('lang.smartlink.listening') }}</span>
          <span v-else-if="scope.row.options.status == 'partial connected'">{{ $t('lang.smartlink.partialConnected')
          }}</span>
          <span v-else-if="scope.row.options.status == 'unknown'">{{ $t('lang.smartlink.unknown')
          }}</span>
          <span v-else-if="scope.row.options.enabled == '1' && !scope.row.options.status">{{
            $t('lang.smartlink.unknown') }}</span>
          <span v-else-if="!scope.row.options.enabled || scope.row.options.status == 'disconnected'">{{
            $t('lang.smartlink.disconnect') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.smartlink.connectNumber')}`">
        <template slot-scope="scope">
          <span v-if="scope.row.options.conn_num === '' && scope.row.options.enabled != '1'">-</span>
          <span v-else-if="scope.row.options.enabled == '1' && scope.row.options.conn_num === ''"></span>
          <span v-else-if="scope.row.options.enabled == ''">-</span>
          <span v-else>{{ scope.row.options.conn_num }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.smartlink.protocal')}`">
        <template slot-scope="scope">
          <span
            v-if="scope.row.options.mode === 'Modbus TCP Master' || scope.row.options.mode === 'Modbus TCP Slave'">{{
              protocal[scope.row.options.proto_mbtcp] }}</span>
          <span
            v-else-if="scope.row.options.mode === 'Modbus RTU Master' || scope.row.options.mode === 'Modbus RTU Slave'">{{
              protocal[scope.row.options.proto_mbrtu] }}</span>
          <span
            v-else-if="scope.row.options.mode === 'Modbus ASCII Master' || scope.row.options.mode === 'Modbus ASCII Slave'">{{
              protocal[scope.row.options.proto_mbascii] }}</span>
          <span v-else>{{ protocal[scope.row.options.proto] || scope.row.options.proto }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.Button.operation')}`" min-width="100px">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="connEdit(scope.row, scope.$index)">{{ $t('lang.Button.edit')
          }}</el-button>
          <el-button v-if="!nms" type="danger" :disabled="noSname === false ? false : true" size="small"
            @click="connDelet(scope.row, scope.$index)">{{ $t('lang.Button.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button v-if="!nms" :disabled="noSname === false ? false : true" class="add-button" type="primary" size="small"
      @click="addConn">{{ $t('lang.Button.Add') }}</el-button>
    <cont-dialog ref="connDialog" @updateData="updateData" :deviceDid="deviceDid" :deviceSn="deviceSn" :com="com"
      :deviceSoftwareVer="deviceSoftwareVer" :vendorName="vendorName" :nms="nms"></cont-dialog>
  </div>
</template>
<script>
import contDialog from './contDialog'
import { updateConfig } from "@/api/configurationlist";
import { workModel, protocal } from './connConfig'

export default {
  props: ['Conn', 'deviceDid', 'deviceSn', 'com', 'noSname', 'vendorName', 'deviceSoftwareVer', 'nms'],
  components: {
    contDialog,
  },
  data() {
    return {
      workModel,
      // 协议
      protocal,
      devName: ['Modbus RTU Master', 'Modbus RTU Slave', 'UART', 'Modbus ASCII Master', 'Modbus ASCII Slave'], //设备名称
    }
  },
  computed: {

  },
  methods: {
    // 修改连接配置
    connEdit(row, index) {
      this.$refs.connDialog.show(row, index)
    },
    // 添加连接配置
    addConn() {
      this.$refs.connDialog.show('', this.Conn.length)
    },
    connDelet(row, index) {
      this.$confirm(this.$t('lang.Button.isDelete'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.submit'),
        cancelButtonClass: this.$t('lang.Button.cancel'),
        type: 'warning',
        center: true
      }).then(() => {
        updateConfig(this.deviceSn, this.deviceDid, [
          {
            section: "conn",
            config: "smartlink",
            action: 2,
            index: [index],
            // server: "smartlink",
            // options: {
            //   ...row.options
            // },
            lists: row.lists
          },
        ]).then(res => {
          if (res.data.data.mess === 0) {
            this.$message.success(this.$t('lang.Button.successDelete'))
            this.$emit('updateData')
            this.dialogVisible = false
          } else {
            this.$message.error(this.$t('lang.Button.failDelete'))
          }
        })
      });
    },
    updateData() {
      this.$emit('updateData')
    }
  },
  watch: {
    deviceSn: {
      handler: function (val) {
        console.log(this.deviceSn);

      }
    },
    // deviceSoftwareVer:{
    //   immediate: true,
    //   handler() {
    //      console.log('version');
    //     console.log(this.deviceSoftwareVer);
    //     console.log(this.deviceSoftwareVer.indexOf('v2.2'));
    //     this.$set(this.workModel, '')
    //   }
    // }
  },

}
</script>
<style scoped>
.add-button {
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>